// Google Ads language for a market. Volumes must be requested in the market's own
// language: asking for English-language searches in the Netherlands returns a
// different number from Dutch-language searches, and the UI would present it as
// the Dutch figure. Mirrors server/services/keywordEnrichmentService.js.
const COUNTRY_TO_LANGUAGE: Record<string, string> = {
  UK: 'en', US: 'en', AU: 'en', CA: 'en', COM_US: 'en', GLOBAL: 'en',
  NL: 'nl', DE: 'de', FR: 'fr', IT: 'it', ES: 'es', MX: 'es', AR: 'es',
  COM: 'es', // nuevayork.com - LatAm Spanish (Charlotte, 2026-09-10)
  BR: 'pt', SE: 'sv', NO: 'no', DK: 'da', FI: 'fi', JP: 'ja', KR: 'ko',
  RU: 'ru', CN: 'zh',
};

export function languageForCountry(country?: string | null): string {
  return COUNTRY_TO_LANGUAGE[String(country || '').toUpperCase()] || 'en';
}
